/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Tabs, Input, Button, Icon, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import BarangayTerm from './BarangayTerm'
import BarangayPositions from './Positions'
import Purok from './Purok'
import ReservationTypes from './ReservationTypes'
import ShiftSchedule from './ShiftSchedule'
import Equipments from './Equipments'

const { TabPane } = Tabs

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">Data Lookup Management</li>
								</ol>
							</div>
							<h4 className="page-title">Data Lookup Management</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Tabs defaultActiveKey="barangay-term">
									<TabPane tab="Barangay Term" key="barangay-term">
										<BarangayTerm />
									</TabPane>
									<TabPane tab="Positions" key="positions">
										<BarangayPositions />
									</TabPane>
									<TabPane tab="Purok" key="purok">
										<Purok />
									</TabPane>
									<TabPane tab="Facilities" key="facilities">
										<ReservationTypes />
									</TabPane>
									<TabPane tab="Equipment" key="equipments">
										<Equipments />
									</TabPane>
									{/* <TabPane tab="Shift Schedule" key="shift-schedule">
										<ShiftSchedule />
									</TabPane> */}
								</Tabs>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
